/**
 * SendGiftTargetType enum
 * The destination of a send-gift action.
 * Web-only discriminator (no Flutter enum equivalent — Flutter splits these
 * into separate send paths). Not serialized over the wire.
 */
export enum SendGiftTargetType {
  media = 0,
  chat = 1,
  videoCall = 2,
  liveStreaming = 3,
}
